<template>
  <div v-if="img">
  <center v-if="data.IconsAlign === 'center'">
    <v-img
      :src="img"
      style="width:120px; height:auto;"
    />
  </center>
  <v-img
    v-else-if="data.IconsAlign === 'left'"
    :src="img"
    style="width:120px; height:auto;margin-right:0"
  />
  <div v-else
    class="d-flex justify-end"
  >
    <div>
      <v-img
        :src="img"
        style="width:120px; height:120px;"
      />
    </div>
  </div>
  </div>
</template>

 <script>
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data() {
      return {
        img: null
      }
    },
    computed: {
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      }
    },
    watch: {
      'data.IconsURL' (v) {
        this.img = v
      }
    },
    mounted() {
      this.img = this.data.IconsURL
    }
  }
</script>
